import React from "react";

// POS home-screen action buttons (include_buttons_register3): Custom Item, Quick Add, Discounts,
// Coupons, OTD Price, Issue Gift Card. Deferred (shown disabled): Time Clock.
//
// Each carries a glyph as well as a label: on narrow screens the labels shrink but the glyph keeps
// the button identifiable, and repeat users navigate by shape long before they read the word.
const ITEMS = [
  { key: "custom", glyph: "✎", label: "Custom Item" },
  { key: "quick", glyph: "＋", label: "Quick Add" },
  { key: "discount", glyph: "％", label: "Discounts" },
  { key: "coupon", glyph: "◫", label: "Coupons" },
  { key: "otd", glyph: "◎", label: "OTD Price" },
  { key: "gift", glyph: "▣", label: "Issue Gift Card" },
  // Android ⋮ popup-menu cash operations (setupPopupMenu) — surfaced as buttons: the column has room.
  { key: "vendor", glyph: "⇄", label: "Vendor Payout" },
  { key: "drop", glyph: "⬇", label: "Drop Cash" },
  { key: "payin", glyph: "⬆", label: "Pay In" },
  { key: "nosale", glyph: "⏏", label: "No Sale" },
];

export default function ActionColumn({ onCustomItem, onQuickAdd, onDiscount, onCoupon, onOtd, onIssueGiftCard, onVendorPayout, onDropCash, onPayIn, onNoSale, onLotteryPayout, showLotteryPayout = false }) {
  // Android setupPopupMenu: "Lottery/Scratcher Payout" is offered only when the store's `ebt`
  // register setting contains "4".
  const items = showLotteryPayout ? [...ITEMS, { key: "lottery", glyph: "🎟", label: "Lottery/Scratcher Payout" }] : ITEMS;
  const handlers = {
    lottery: onLotteryPayout,
    custom: onCustomItem,
    quick: onQuickAdd,
    discount: onDiscount,
    coupon: onCoupon,
    otd: onOtd,
    gift: onIssueGiftCard,
    vendor: onVendorPayout,
    drop: onDropCash,
    payin: onPayIn,
    nosale: onNoSale,
  };
  return (
    <div className="qv-actions">
      {items.map((it) => (
        <button key={it.key} type="button" className="qv-btn" onClick={handlers[it.key]}>
          <span className="qv-act-glyph" aria-hidden="true">{it.glyph}</span>
          <span className="qv-act-label">{it.label}</span>
        </button>
      ))}
      <button type="button" className="qv-btn qv-btn--ghost" disabled title="Coming soon">
        <span className="qv-act-glyph" aria-hidden="true">◷</span>
        <span className="qv-act-label">Time Clock</span>
      </button>
    </div>
  );
}
